import { jsx } from 'react/jsx-runtime';
import { useContext, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import isEqual from 'lodash.isequal';
import { SelectListContext } from '../../SelectList.Context/SelectList.Context.es.js';
import { SelectListItemBase } from './SelectList.Item.Base.es.js';

const SelectListItemLink = ({ item, truncate, handleSelect, disabled, className, children, selectedStyle = 'primary', innerRef, ...rest })=>{
    const { selected } = useContext(SelectListContext);
    const { value } = item ?? {};
    const isSelected = useMemo(()=>{
        const selectedItems = Array.isArray(selected) ? selected : [
            selected
        ];
        return selectedItems.some((selected)=>{
            return isEqual(selected?.value, value);
        });
    }, [
        selected,
        value
    ]);
    const handleSelectItem = useCallback(()=>{
        handleSelect?.(item);
    }, [
        handleSelect,
        item
    ]);
    const selectListItemClasses = classNames('cb-select-list-item', selectedStyle, className, {
        selected: isSelected,
        disabled
    });
    return jsx("a", {
        "aria-selected": isSelected,
        className: selectListItemClasses,
        onClick: handleSelectItem,
        ...rest,
        children: jsx(SelectListItemBase, {
            isSelected: isSelected,
            item: item,
            selectedStyle: selectedStyle,
            subcomponents: children,
            truncate: truncate
        })
    });
};
SelectListItemLink.displayName = 'SelectListItem.Link';

export { SelectListItemLink as default };
//# sourceMappingURL=SelectList.Item.Link.es.js.map
